import React from "react";
import { getMessage } from "CONFIG/i18n";

// Components
import HeaderContainer from "COMPONENTS/Header/HeaderContainer";

import "./SessionEndScreen.less";

const SessionEndScreen = (props) => {
  return (
    <div>
      <section className="bgColor">
        <HeaderContainer />
        <div className="topMargin sessionEndScreen">
          <div className="sessionEndMessage">
            <div>
              {getMessage("SESSION_ENDED")}
            </div>
            <div>
              {getMessage("CLOSE_BROWSER")}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SessionEndScreen;
